import { AuthAction, AuthActionType } from './actions';

interface AuthState {
	token: string;
}

export const defaultAuthState = { token: '' };

export function authReducers(
	state: AuthState = defaultAuthState,
	action: AuthAction
): AuthState {
	const { type } = action;

	switch (type) {
	case AuthActionType.Clear:
		return {
			...defaultAuthState
		};

	case AuthActionType.Update:
		return {
			token: action.data
		};
	default:
		return state;
	}
}
